import { TFunction } from "i18next";
import { ApplicationCreationForm } from "../../domain/models/dto/ApplicationDTO";
import { Fields } from "../../types/SchemaFactory";
import { schemaFactory } from "../SchemaFactory";
import { priceFields } from "../PriceSchema";

export const applicationCreationFields: Fields<ApplicationCreationForm> = {
    comment: {
        min: 2,
        max: 500,
        required: false,
        placeholderKey: "work.applicationCreation.commentPlaceholder",
        type: "text",
        initial: "",
    },
    price: {
        min: 1,
        max: 1,
        required: true,
        type: "schema",
        schema: priceFields,
        initial: null,
        placeholderKey: "",
    },
};

export const applicationCreationSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, applicationCreationFields);
};
